function updatePostPopularity() {
    const attribute = document.querySelector('[data-update-post-popularity]');

    if (attribute !== null) {
      $.ajax({
        type: 'POST',
        url: window.fpgmedia_js_params ? window.fpgmedia_js_params.ajaxurl : '/wp-admin/admin-ajax.php',
        data: {
          action: 'update_post_popularity',
          post_id: attribute.dataset.updatePostPopularity,
        },
      });
    }
}

export default function() {
  updatePostPopularity();
  $(window).on('fpgmedia:post_loaded', updatePostPopularity);
}



// WEBPACK FOOTER //
// ./scripts/components/popular-posts.js